// extracted by mini-css-extract-plugin
module.exports = {"commentContainer":"ActionViewCommentsContainer_commentContainer__gdj1K"};